// extracted by mini-css-extract-plugin
export default {"container":"HeatmapCanvas_container__ooCu6"};